<!--
This is only the drag area/button component, then it calls the UploadForm.vue
which handles the posting to the API (which handles the storage)
-->
<template>
    <b-field class="file">
        <b-upload
            v-model="file"
            :multiple=true
            @input="UploadFormModal(file)">

            <a class="button is-light">
                <b-icon icon="upload" type="is-primary"></b-icon>
                <span>Upload</span>
            </a>
        </b-upload>
    </b-field>
</template>

<script>
    // Import the UploadForm Component
    import UploadForm from './UploadForm.vue'

    export default {
        data() {
            return {
                file: [],
            }
        },
        methods: {
            UploadFormModal(file) {
                let modaldia = this.$buefy.modal.open({ // used to be this.$modal.open, when did that change!
                    parent: this,
                    component: UploadForm,
                    hasModalCard: true,
                    props: {'files': file},
                    onCancel: () => { // took me ages to find, found via vue chrome plugin
                        this.Cancelled()
                    }
                })
                console.info('file', this.file)
            },
            Cancelled() {
                console.log('User cancelled dialog')
                this.file = []
            }
        },
    }
</script>
